import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import MapView from "./MapView"; // Assurez-vous que le chemin d'importation est correct

const SCENARIOS = [
  {
    nom: "Blé intensif",
    mo: [1.3, 1.32, 1.35, 1.37, 1.38, 1.39, 1.41, 1.43, 1.45, 1.46],
    description: "Culture intensive du blé avec fertilisation classique.",
    pratiques: ["Labour profond", "Fertilisation azotée", "Irrigation standard"]
  },
  {
    nom: "Légumineuses + fertilisation réduite",
    mo: [1.3, 1.35, 1.38, 1.42, 1.46, 1.5, 1.55, 1.6, 1.65, 1.7],
    description: "Rotation avec légumineuses et réduction des apports d'engrais.",
    pratiques: ["Rotation culturale", "Engrais vert", "Fertilisation réduite"]
  },
  {
    nom: "Couverts végétaux + non-labour",
    mo: [1.3, 1.34, 1.37, 1.41, 1.45, 1.5, 1.56, 1.62, 1.68, 1.75],
    description: "Utilisation de couverts végétaux et suppression du labour.",
    pratiques: ["Couverts végétaux", "Non-labour", "Gestion de l'irrigation"]
  },
  {
    nom: "Bio + compost + irrigation optimisée",
    mo: [1.3, 1.36, 1.41, 1.47, 1.53, 1.6, 1.68, 1.77, 1.87, 1.98],
    description: "Agriculture biologique, apport de compost et irrigation optimisée.",
    pratiques: ["Compost", "Irrigation optimisée", "Semis direct", "Bio"]
  },
  {
    nom: "Maïs + irrigation intensive",
    mo: [1.3, 1.31, 1.33, 1.36, 1.39, 1.41, 1.44, 1.47, 1.5, 1.52],
    description: "Culture intensive du maïs avec irrigation soutenue.",
    pratiques: ["Maïs intensif", "Irrigation intensive", "Fertilisation minérale"]
  }
];

const layers = [
  "Projet_MOS_Essai:BDPPAD_2024_MRC_MOS",
  "Projet_MOS_Essai:IAC-2024_MRC",
  "Projet_MOS_Essai:meteo_data"
];

export default function Scenarios({ onNavigate }) {
  const [scenarioIdx, setScenarioIdx] = useState(0);
  const [activeLayer, setActiveLayer] = useState(layers[0]);
  const [visibleLayers, setVisibleLayers] = useState([layers[0]]);
  const chartData = {
    labels: Array.from({ length: 10 }, (_, i) => 2016 + i),
    datasets: [
      {
        label: SCENARIOS[scenarioIdx].nom,
        data: SCENARIOS[scenarioIdx].mo,
        borderColor: "#a3b18a",
        backgroundColor: "rgba(163,177,138,0.2)",
        tension: 0.2,
      },
    ],
  };

  return (
    <div
      style={{
        width: "100vw",
        minHeight: "100vh",
        maxWidth: "none",
        margin: 0,
        padding: "3em 0",
        background: "#f6f8f5",
        borderRadius: 0,
        position: "relative",
      }}
    >
      {/* Bouton retour */}
      <button
        style={{
          position: "absolute",
          top: "1em",
          left: "1em",
          padding: "0.5em 1.2em",
          background: "#2a4d1b",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
          zIndex: 100,
        }}
        onClick={() => onNavigate("accueil")}
      >
        ← Retour à l’accueil
      </button>
      <div style={{ maxWidth: 1400, margin: "0 auto" }}>
        <h3 style={{ marginTop: "1.5em", fontSize: "1.4em", fontWeight: "bold", color: "#232b21" }}>Scénarios</h3>
        <h4 style={{ fontSize: "1em", color: "#39433a", marginBottom: "1em" }}>Simulation de différentes pratiques</h4>
        <select
          value={scenarioIdx}
          onChange={e => setScenarioIdx(Number(e.target.value))}
          style={{
            fontSize: "1em",
            padding: "0.5em 1em",
            borderRadius: "6px",
            border: "1px solid #ccc",
            marginBottom: "1em",
          }}
        >
          {SCENARIOS.map((s, idx) => (
            <option key={s.nom} value={idx}>{s.nom}</option>
          ))}
        </select>
        <h4 style={{ fontSize: "1em", color: "#39433a", marginBottom: "1em" }}>Graphique d’évolution de la M.O. selon scénario</h4>
        <div style={{
          width: "100%",
          maxWidth: "700px",
          marginTop: "1em",
          background: "#232b21",
          borderRadius: "8px",
          padding: "18px",
        }}>
          <Line data={chartData} />
        </div>
        <div style={{ margin: "2em 0", background: "#e6e6d6", borderRadius: 8, padding: "1.2em", maxWidth: 700 }}>
          <h4 style={{ color: "#232b21", fontWeight: "bold", marginBottom: "0.5em" }}>Détails du scénario sélectionné</h4>
          <div style={{ fontSize: "1.05em", color: "#39433a", marginBottom: "0.5em" }}>
            <b>Description :</b> {SCENARIOS[scenarioIdx].description}
          </div>
          <div style={{ fontSize: "1em", color: "#166534" }}>
            <b>Pratiques simulées :</b> {SCENARIOS[scenarioIdx].pratiques.join(", ")}
          </div>
        </div>
        <div style={{ marginTop: "2em" }}>
          <button
            style={{
              background: "#a3b18a", color: "#39433a", padding: "0.6em 1.3em",
              borderRadius: "8px", border: "none", marginRight: "1em", cursor: "pointer"
            }}
            onClick={() => alert("Validation effectuée")}
          >
            Valider
          </button>
          <button
            style={{
              background: "#7a7c76", color: "#fff", padding: "0.6em 1.3em",
              borderRadius: "8px", border: "none", marginRight: "1em", cursor: "pointer"
            }}
            onClick={() => alert("Régénération effectuée")}
          >
            Régénérer
          </button>
          <button
            style={{
              background: "#39433a", color: "#a3b18a", padding: "0.6em 1.3em",
              borderRadius: "8px", border: "1px solid #a3b18a", cursor: "pointer"
            }}
            onClick={() => alert("PDF exporté")}
          >
            Export PDF
          </button>
        </div>
        <MapView activeLayer={activeLayer} visibleLayers={visibleLayers} />
        {/* Ajoute ici une carte ou un résumé des pratiques agricoles simulées si besoin */}
      </div>
    </div>
  );
}